import { RouteComponentProps } from '@reach/router';
import React from 'react';

interface Props extends RouteComponentProps {}

export const Login: React.FC<Props> = () => {
  return <>login please</>
}